import axios from "axios";

import { api } from "../../apis";
import { helperFunction } from "../../constant/helper";
import { types } from "../type";

// set loading
const setCanteenLoading = (data) => (dispatch) => {
  dispatch({
    type: types.CanteenTypes.CANTEEN_SET_LOADING,
    payload: data
  });
};

// set loading
const setRulesCreateLoading = (data) => (dispatch) => {
  dispatch({
    type: types.CanteenTypes.CREATE_CANTEEN_SET_LOADING,
    payload: data
  });
};

// clear result
const clearCanteenResult = () => (dispatch) => {
  dispatch({
    type: types.CanteenTypes.CANTEEN_CLEAR_RESULT
  });
};

// clear error
const clearCanteenErrors = () => (dispatch) => {
  dispatch({
    type: types.CanteenTypes.CANTEEN_CLEAR_ERRORS
  });
};

// unmount result
const unmountCanteenData = () => (dispatch) => {
  dispatch({
    type: types.CanteenTypes.CANTEEN_UNMOUNT
  });
};

const getFunction = async (
  url,
  type,
  errorType,
  dispatch,
  payloadData = []
) => {
  try {
    const getRequestSuccess = await axios.get(url);
    const { data } = getRequestSuccess;
    dispatch({
      type: type,
      payload: { data, payloadData }
    });
    // console.log(data);
  } catch (getRequestError) {
    const errorData = {
      data: getRequestError.response.data,
      status: getRequestError.response.status
    };
    dispatch({
      type: errorType,
      payload: errorData
    });
  }
};

// get  daily Canteen
const getDailyCanteen = (
  date,
  locationId,
  loginType,
  dataToGetDailyCanteen,
  selectedCategory
) => async (dispatch) => {
  const { baseUrlNode } = await helperFunction.checkLoginType(
    loginType
  );
  const url = `${baseUrlNode}${api.Canteen_Api.GET_DAILY_CANTEEN_API}/${date}/${locationId}/${dataToGetDailyCanteen}/${loginType}`;
  const type = types.CanteenTypes.GET_DAILY_CANTEEN;
  const errorType = types.CanteenTypes.CANTEEN_GET_ERRORS;
  dispatch({
    type: types.CanteenTypes.DAILY_ATT_INPUTS,
    payload: {
      date,
      locationId,
      selectedCategory
    }
  });
  getFunction(url, type, errorType, dispatch, selectedCategory);
};

// get  attendance sheet
const getCanteenSheet = (
  fromDate,
  toDate,
  locationId,
  loginType,
  canteenType,
  dataFormat
) => async (dispatch) => {
  const { baseUrlNode } = await helperFunction.checkLoginType(
    loginType
  );
  const url = `${baseUrlNode}${api.Canteen_Api.GET_CANTEEN_SHEET_API}/${fromDate}/${toDate}/${locationId}/${loginType}/${canteenType}`;
  const type = types.CanteenTypes.GET_CANTEEN_SHEET;
  const errorType = types.CanteenTypes.CANTEEN_GET_ERRORS;
  dispatch({
    type: types.CanteenTypes.SHEET_INPUTS,
    payload: {
      fromDate,
      toDate,
      locationId,
      dataFormat
    }
  });
  getFunction(url, type, errorType, dispatch);
};

// get  all  Canteen rule
const getCanteenRule = (locationId, loginType) => async (
  dispatch
) => {
  const { baseUrlNode } = await helperFunction.checkLoginType(
    loginType
  );
  const url = `${baseUrlNode}${api.Canteen_Api.GET_CANTEEN_RULES_API}/${locationId}/${loginType}`;
  const type = types.CanteenTypes.GET_CANTEEN_RULE;
  const errorType = types.CanteenTypes.CANTEEN_GET_ERRORS;

  getFunction(url, type, errorType, dispatch);
};

const createCanteenRules = (canteenRuleInfo, loginType) => async (
  dispatch
) => {
  try {
    const { baseUrlNode } = await helperFunction.checkLoginType(
      loginType
    );
    const ruleCreateSuccess = await axios.post(
      `${baseUrlNode}${api.Canteen_Api.CREATE_CANTEEN_RULES_API}/${loginType}`,
      canteenRuleInfo
    );
    const { data } = ruleCreateSuccess;
    dispatch({
      type: types.CanteenTypes.CREATE_CANTEEN_RULE,
      payload: data
    });
  } catch (ruleCreateError) {
    const errorData = {
      data: ruleCreateError.response.data,
      status: ruleCreateError.response.status
    };
    console.log(errorData);
    dispatch({
      type: types.CanteenTypes.CANTEEN_GET_ERRORS,
      payload: errorData
    });
  }
};

export {
  getCanteenSheet,
  getDailyCanteen,
  setCanteenLoading,
  clearCanteenResult,
  clearCanteenErrors,
  unmountCanteenData,
  createCanteenRules,
  getCanteenRule,
  setRulesCreateLoading
};
